import { type Node, type NodeProps, Position } from '@xyflow/react';
import React from 'react';

import { BaseNode, type NodeData } from './BaseNode';
import { NodeHandle } from './NodeHandle';

export type DatasetNodeType = Node<NodeData, 'custom_dataset'>;

export const DatasetNode: React.FC<NodeProps<DatasetNodeType>> = ({
  id,
  data,
  selected,
}) => {
  const outputPort = (data.config?.output_port as string) || 'data';
  const datasetId = data.config?.dataset_id as string;

  const subtitle = datasetId ? `ID: ${datasetId}` : undefined;

  // Extract connection state from node data for consistency (source-only node)
  const activeConnection = data.activeConnection;
  const isActiveConnection = !!activeConnection;

  return (
    <BaseNode
      nodeId={id}
      data={data}
      category="io"
      subtitle={subtitle}
      selected={selected}
    >
      {/* Config input handle for dataset_id */}
      <NodeHandle
        type="target"
        position={Position.Left}
        id="dataset_id"
        blockId={id}
        isActiveConnection={isActiveConnection}
        isConfigPort={true}
      />
      {/* Output handle for dataset blocks */}
      <NodeHandle
        type="source"
        position={Position.Right}
        id={outputPort}
        blockId={id}
        isActiveConnection={isActiveConnection}
      />
    </BaseNode>
  );
};
